import { render } from "./PaymentCollection.vue?vue&type=template&id=1e2ece22"
import script from "./PaymentCollection.vue?vue&type=script&lang=js"
export * from "./PaymentCollection.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__